import { useEffect, useRef } from "react";

const DEFAULT_TITLE = "Keyz's Epic Adventure Tours | Best Tours & Excursions in Saint Lucia";
const DEFAULT_DESC = "Book the best Saint Lucia tours and excursions. Luxury catamaran cruises, Pitons hikes, rainforest zip-lining, snorkeling safaris, sunset sails, island combos & kids packages. Top-rated tour operator. Book online today!";
const DEFAULT_IMAGE = "https://images.unsplash.com/photo-1605288132419-1aa5e25475b2?w=1200&q=80";

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const useSEO = ({ title, description, image, url, type = "website", jsonLd } = {}) => {
  const jsonLdStr = jsonLd ? JSON.stringify(jsonLd) : "";
  const prevTitle = useRef(null);

  useEffect(() => {
    const fullTitle = title ? `${title} | Keyz's Epic Adventure Tours` : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    const img = image || DEFAULT_IMAGE;

    document.title = fullTitle;
    prevTitle.current = fullTitle;

    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:image", img);
    setMeta("property", "og:type", type);
    setMeta("property", "og:site_name", "Keyz's Epic Adventure Tours");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);
    setMeta("name", "twitter:image", img);
    if (url) setMeta("property", "og:url", url);

    // JSON-LD structured data
    if (jsonLdStr) {
      let scriptEl = document.getElementById("seo-jsonld-page");
      if (!scriptEl) {
        scriptEl = document.createElement("script");
        scriptEl.id = "seo-jsonld-page";
        scriptEl.type = "application/ld+json";
        document.head.appendChild(scriptEl);
      }
      scriptEl.textContent = jsonLdStr;
    }

    return () => {
      document.title = DEFAULT_TITLE;
      // Remove page-specific JSON-LD on unmount
      const pageJsonLd = document.getElementById("seo-jsonld-page");
      if (pageJsonLd) pageJsonLd.remove();
    };
  }, [title, description, image, url, type, jsonLdStr]);
};
